export default __webpack_public_path__ + "static/media/wedding.8f5b10b9.jpg";